import { useState } from "react";

const navLinks = [
  { label: "Product", href: "#product" },
  { label: "Solutions", href: "#solutions" },
  { label: "Customers", href: "#customers" },
  { label: "Pricing", href: "#pricing" },
  { label: "Docs", href: "#docs" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-40">
      <nav className="w-full px-6 md:px-10 h-20 flex items-center justify-between text-white">
        {/* Logo + edition */}
        <div className="flex items-center gap-6">
          <a
            href="#"
            className="font-script italic font-semibold text-3xl leading-none tracking-tight cursor-pointer text-white whitespace-nowrap"
          >
            Lumora
          </a>
          <div className="hidden sm:flex items-center gap-2 text-[10px] uppercase tracking-[0.35em] text-white/60 whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-white/70"></span>
            Edition 06 · 2026
          </div>
        </div>

        {/* Center nav */}
        <ul className="hidden md:flex items-center gap-9 text-sm text-white/80">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Right CTA */}
        <div className="hidden md:flex items-center gap-5">
          <a
            href="#sign-in"
            className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            Sign in
          </a>
          <a
            href="#try"
            className="px-5 py-2 rounded-full border border-white/20 bg-black/40 backdrop-blur-md text-sm text-white hover:bg-white hover:text-black transition-colors cursor-pointer whitespace-nowrap"
          >
            Try free
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          aria-label="Toggle menu"
          onClick={() => setMobileOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white cursor-pointer"
        >
          <i
            className={
              mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"
            }
          ></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-black/85 backdrop-blur-md border-t border-white/10 px-6 py-6 text-white">
          <ul className="flex flex-col gap-4 text-sm">
            {navLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="block py-1 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="pt-2 border-t border-white/10 flex items-center justify-between">
              <a href="#sign-in" className="cursor-pointer">
                Sign in
              </a>
              <a
                href="#try"
                className="px-4 py-2 rounded-full border border-white/20 cursor-pointer whitespace-nowrap"
              >
                Try free
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}